require('./helpers/bundle-manifest').register(JSON.parse("{\"4V15H\":\"index.4fa7689e.js\",\"fyAIj\":\"element.59295cb1.gltf\"}"));